<template>
  <v-dialog scrollable persistent v-model="config.status.active" :max-width="getLayoutName === 'clients' ? 800 : 600">
    <PeopleLayout
      ref="layout"
      :parent="getParent"
      :client="getClient"
      @done="done"
      @close="close"
    />
  </v-dialog>
</template>

<script>
import PeopleLayout from './layouts/people'
export default {
  name: 'authorAccoutantModalsEditor',
  props: [ 'item' ],
  components: {
    PeopleLayout
  },
  data () {
    return {
      config: {
        status: {
          loading: false,
          active: false
        }
      },
      meta: {
      },
      form: {
        valid: true
      },
      store: {
        layout: ''
      }
    }
  },
  methods: {
    preSubmit: function (req) {
      const { type } = req
      const { id } = this.$props.item || {}
      const urls = {
        children: `${this.$url.api}accountant/get/children/${id}`
      }
      const fds = {
        children: {}
      }
      if (type && urls[type] && fds[type]) {
        if (type === 'children') {
          this.$set(this.config.status, 'loading', true)
          return { type, url: urls[type], fd: fds[type] }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { type, url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({
                type,
                data: res.data.data
              })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const { type, data } = req || {}
      if (type === 'arrange') {
        this.$set(this.config.status, 'loading', false)
        if (data.length) {
          this.$set(this.form, 'arrange', data[data.length - 1].type)
        }
      } else if (type === 'client') {
        this.$set(this.config.status, 'searching', false)
        this.$set(this.store, 'clients', data)
      } else if (type === 'insert') {
        this.emitSocket(req)
        this.$set(this.config.status, 'loading', false)
        this.$emit('done', req)
        this.$emit('close')
      } else if (type === 'update') {
        this.emitSocket(req)
        this.$set(this.config.status, 'loading', false)
        this.$emit('done', req)
        this.$emit('close')
      } else if (type === 'remove') {
        this.emitSocket(req)
        this.$set(this.config.status, 'loading', false)
        this.$emit('done', req)
        this.$emit('close')
      }
    },
    failSubmit: function () {
      this.$set(this.config.status, 'loading', false)
    },
    open: function () {
      this.$set(this.config.status, 'active', true)
      this.$nextTick(() => {
        this.$refs.layout.init()
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    done: function (req) {
      this.$emit('done')
    }
  },
  computed: {
    isSetItem () {
      return !!this.$props.item
    },
    getParent () {
      return this.$props.item || ''
    },
    getClient () {
      const { client } = this.$props.item || { client: {} }
      return client.type === 'company' ? {} : client
    },
    getLayoutName () {
      const { client, type, cid } = this.$props.item || { client: {}, type: '', cid: '' }
      if (['drefunds', 'prefunds'].includes(type)) {
        return 'refund'
      } else if (client.type === 'company') {
        return 'people'
      } else {
        if (['deposites', 'drefunds', 'dcpayments', 'commissions'].includes(type)) {
          if (cid) {
            return 'person' 
          } else {
            return 'people'
          }
        } else {
          return 'person'
        }
      }
    }
  }
}
</script>